import FillInTableProvider from "@/components/business/FillInTableContainer/components/FillInTableProvider/FillInTableProvider";
import { useSafeLeavePage } from "@hooks/useSafeLeavePage";

import FillInTable from "./components/FillInTable/FillInTable";

const FillInTableContainer = () => {
  useSafeLeavePage();

  return (
    <FillInTableProvider>
      <FillInTable />
    </FillInTableProvider>
  );
};

export default FillInTableContainer;
